<template>
    <!-- mobile--consult -->
    <div class="mobile-consult-wrapper">
      <div class="mobile-consult-main">
        <!-- <div><a href="tel:15345810586">咨询电话</a></div>
        <div class="mobile-border">|</div> -->
        <div @click="toBuy">点击购买</div>
        <!-- <div class="mobile-border">|</div>
        <div><a href="tel:15345810586">售后咨询</a></div> -->
      </div>

      <pcPayment @payClose="payShow = false" :payModal="payShow"></pcPayment>
    </div>
</template>

<script>
import $ from 'jquery'
import { mapGetters, mapActions } from 'vuex'
import pcPayment from '../components/pcPayment.vue'

import {
  getPayQrCode,
  getUserPayOrderStatus,
} from '@/api/api'

export default {
  name: 'mobileConsult',
  components: {
    pcPayment
  },
  computed: {
    ...mapGetters(['token'])
  },
  data () {
    return {
      payShow: false,
      buyType: 10, // 10支付宝11微信
      buyTltle: '请使用支付宝APP扫码完成支付',
      orderObj: {},
      timer:null,
    }
  },
  mounted() {
      $(".cndns-right-item.fw").mouseover(function () {
        $(this).find('.cndns-right-box').show();
      }).mouseout(function () {
          $(this).find('.cndns-right-box').hide();
      });
  },
  methods: {
    toBuy(){
      if (this.token) {
        this.payShow = true
        // alert("移动端购买！")
      } else {
        this.$router.push({
          path: '/login'
        })
      }
    },
    closeBtn () {
      clearInterval(this.timer)
      this.payShow = false
    },
    choice (type) {
      this.buyType = type
      if (type == 10) {
        this.buyTltle = '请使用支付宝APP扫码完成支付'
      } else {
        this.buyTltle = '请使用微信APP扫码完成支付'
      }
      this.getPayCode()
    },
    getPayCode () {
      clearInterval(this.timer)
      let data = {
        type: this.buyType
      }
      getPayQrCode(data).then(res => {
        if (res.status == 200) {
          // this.$message.success("注册成功")
          this.orderObj = res.body;
          this.getUserPayOrderStatus()
          
        }
      })
    },
    getUserPayOrderStatus(){
      this.timer = setInterval(()=>{
        let params = {
          orderNo: this.orderObj.orderNo
        }
        getUserPayOrderStatus(params).then(res => {
          if (res.status == 200) {
            if(res.body){
              this.payShow = false;
              this.$message.success("支付成功")
              clearInterval(this.timer)
            }
          }
        })
      },2000) 
    },
  },
  beforeDestroy(){
    clearInterval(this.timer)
  }
}


</script>

<style lang="scss" scoped>
.mobile-consult-wrapper{
  display: none;
}




//  移动端
@media screen and (min-width: 300px) and (max-width: 760px) {
  .mobile-consult-wrapper{
    width: 100%;
    display: block;
    position: fixed;
    z-index: 9;
    bottom: 0;
    left: 0;
    height: 40px;
    line-height: 40px;
    background: #f3f3f3;
    color: rgb(0, 105, 234);
    .mobile-consult-main{
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      a{
        color: rgb(0, 105, 234);
      }
    }
  }
    
}
</style>


